export const YEAR = $localize`:@@hermes_global.year:`;
export const MONTH = $localize`:@@hermes_global.month:`;
export const DAY = $localize`:@@hermes_global.day:`;
export const OF = $localize`:@@hermes_global.of:`;
